import { OptionsEditor } from "./OptionsEditor"
import { PlaceholderInspector } from "./PlaceholderInspector"
import type { ControlInspector } from "./types"

export const dropdownSingle: ControlInspector<"dropdownSingle"> = {
  Inspector: ({ field, onEdit }) => (
    <>
      <OptionsEditor
        eyebrow="Menu options"
        legend="Dropdown choices"
        options={field.options}
        onChange={(options) => onEdit({ options })}
      />
      <PlaceholderInspector placeholder={field.placeholder} onEdit={onEdit} />
    </>
  ),
}
